import React, { useContext, useState } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import { Close } from "@material-ui/icons";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal, CloseAtRight, FontButton } from "../styles/Emissao";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

import { notify } from "../../../../utils/notify";
import UploadFiles from "../../../../components/uploadFiles/UploadFiles";
import { updateXml } from "../../../../repositories/qerpapi/erp/nf/v1/NotafiscalRepository";
import getBase64 from "../../../../utils/getBase64";

const ModalAtualizaXml = ({ openModal, setOpenModal, nfe, setMainLoading }) => {
  const { queryParams } = useContext(QueryParamsContext);
  const [fileList, setFileList] = useState([]);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleUpdateXML = () => {
    if (!fileList.length > 1) {
      return notify("Não é possível realizar o upload de dois ou mais XMLs.");
    }
    (async () => {
      setMainLoading(true);
      const base64 = await getBase64(fileList[0].file);
      const xmlBase64 = base64.split("data:text/xml;base64,")[1];

      const callback = await updateXml(queryParams.empresa_cnpj, nfe.id, {
        usuario_id: queryParams.usuario_id,
        xmlBase64,
      });

      setMainLoading(false);
      if (!callback.success) {
        callback.message.forEach((msg) => notify(msg, true, "warning"));
        return;
      }

      notify(callback.message, true, "success");
      setOpenModal(false);
    })();
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={openModal}
      onClose={handleClose}
      aria-labelledby="dialog-log-nfe"
    >
      <HeaderModal>
        <DialogTitle id="dialog-log-nfe">
          <Grid container wrap="nowrap">
            <Chip
              label={`Atualizar XML da NFe ${nfe.numero}`}
              bgcolor="primary"
              textcolor="white"
            />
            <CloseAtRight>
              <Btn
                onClick={handleClose}
                bgcolor="red"
                hovercolor="darkred"
                startIcon={<Close />}
              />
            </CloseAtRight>
          </Grid>
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid item xs={12} style={{ marginTop: 20 }}>
          <UploadFiles
            multiple={false}
            uploadedFiles={fileList}
            setUploadedFiles={setFileList}
            label="Insira ou arraste o arquivo XML atualizado"
            accept={".xml"}
            previewFile={false}
          />
        </Grid>
      </DialogContent>
      <DialogActions>
        <FontButton>
          <Grid container spacing={2}>
            <Grid item xs />
            <Grid item>
              <Btn
                label="Atualizar XML"
                full="true"
                disabled={!fileList.length}
                onClick={handleUpdateXML}
              />
            </Grid>
          </Grid>
        </FontButton>
      </DialogActions>
    </Dialog>
  );
};

export default ModalAtualizaXml;
